import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import lodashGet from 'lodash/get';
import { useCallback, memo } from 'react';
import ColorInput from '../ColorInput';
function FormikColorPicker(props) {
    const { onColorChange = () => null, name, ...colorPickerProps } = props;
    const { values, setFieldValue } = useFormikContext();
    const colorChangeHandler = useCallback((color) => {
        onColorChange(color);
        setFieldValue(name, color.hex);
    }, [name, onColorChange, setFieldValue]);
    return (_jsx(ColorInput, { ...colorPickerProps, name: name, onColorChange: colorChangeHandler, value: lodashGet(values, name) }));
}
export default memo(FormikColorPicker);
